import Vue from 'vue'
import VueRouter from 'vue-router'

// Traveller views
const Login = () => import('../views/Login.vue')
const SystemOverview = () => import('../views/system/Overview.vue')

// devices
const Infopoints = () => import('../views/devices/Infopoints.vue')
const SseDisplays = () => import('../views/devices/SseDisplays.vue')
const PowerSockets = () => import('../views/devices/PowerSockets.vue')
const Devices = () => import('../views/devices/Devices.vue')
const DeviceGroups = () => import('../views/devices/DeviceGroups.vue')
const DisplayGroups = () => import('../views/devices/DisplayGroups.vue')

// content
const Timetables = () => import('../views/content/Timetables.vue')
const DisplayLayouts = () => import('../views/layout/DisplayLayouts.vue')
const TextAnnouncementsTabs = () => import('../views/TextAnnouncementsTabs.vue')
const ImageAnnouncements = () => import('../views/ImageAnnouncements.vue')
const Channels = () => import('../views/content/Channels.vue')
const Media = () => import('../views/content/Media.vue')
const InfopointLayouts = () => import('../views/content/InfopointLayouts.vue')
const ImportLogs = () => import('../views/timetables/ImportLogs.vue')
const PrintEditor = () => import('../views/print/PrintEditor.vue')

// system
const Users = () => import('../views/system/Users.vue')
const UserGroups = () => import('../views/system/UserGroups.vue')
const ScheduledTasks = () => import('../views/system/ScheduledTasks.vue')
const Organisations = () => import('../views/system/Organisations.vue')
const AirPollutionLimits = () => import('@/views/system/AirPollutionLimits.vue')
const MessagesSettings = () => import('@/views/system/MessagesSettings.vue')
const DeviationColors = () => import('@/views/system/DeviationColors.vue')
const VirtualStops = () => import('@/views/system/VirtualStops.vue')
const Settings = () => import('@/views/system/Settings.vue')
const Maintenance = () => import('@/views/system/Maintenance.vue')

// timetables
const Stops = () => import('../views/timetables/Stops.vue')
const Lines = () => import('../views/timetables/Lines.vue')
const Routes = () => import('../views/timetables/Routes.vue')
const Seasons = () => import('../views/timetables/Seasons.vue')
const DayTypes = () => import('../views/timetables/DayTypes.vue')
const DataImport = () => import('../views/timetables/DataImport.vue')
const ToDo = () => import('../views/ToDo.vue')
const DataImportTable = () => import('../views/content/Imports.vue')

const ComponentTest = () => import('../views/ComponentTest.vue')

// paper dashboard layout
const DashboardLayout = () => import('../components/Dashboard/Layout/DashboardLayout.vue')

// GeneralViews
const Content = () => import('src/components/Dashboard/Layout/Content.vue')

// Map view
const MapView = () => import('../views/MapView.vue')

// Realtime
const Vehicles = () => import('../views/realtime/Vehicles.vue')
const VehicleGroups = () => import('../views/realtime/VehicleGroups.vue')
const DrivingCycles = () => import('../views/realtime/DrivingCycles.vue')
const VehicleReport = () => import('../views/realtime/VehicleReport.vue')
const ReplacementRules = () => import('../views/realtime/ReplacementRules.vue')
const ReplacementRuleConfigs = () => import('../views/realtime/ReplacementRuleConfigs.vue')

// Reports
const TravelTimeReport = () => import('@/views/report/TravelTimeReport.vue')
const PunctualityReport = () => import('@/views/report/PunctualityReport.vue')
const StopPunctualityReport = () => import('@/views/report/StopPunctualityReport.vue')
const BlockReport = () => import('@/views/report/BlockReport.vue')

const TripReport = () => import('@/views/report/TripReport.vue')
const OmittedStopsReport = () => import('@/views/report/OmittedStopsReport.vue')
const VehicleHistoryReport = () => import('@/views/report/OmittedStopsReport.vue')
const ImportLogReport = () => import('@/views/report/ImportLogReport.vue')

// Reports2
const LineDeviationReport = () => import('@/views/report2/LineDeviationReport.vue')
const StopDeviationReport = () => import('@/views/report2/StopDeviationReport.vue')
const VehicleDeviationReport = () => import('@/views/report2/VehicleDeviationReport.vue')

// Reports Opensearch
import DynamicReport from '@/components/ReportOpenSearch/DynamicReport.vue'

// Dispatching
const UserMessages = () => import('../views/dispatching/UserMessages.vue')
const DriverDocuments = () => import('../views/dispatching/DocumentView.vue')
const Events = () => import('@/views/dispatching/Events.vue')
const TrafficDeviations = () => import('@/views/dispatching/TrafficDeviations.vue')
const CanceledDepartures = () => import('@/views/dispatching/TrafficDeviations/CanceledDepartures.vue')
const SystemEventTable = () => import('@/views/dispatching/SystemEventTable.vue')

// Terminals
import TerminalView from '../views/terminals/TerminalView.vue'

// Helsinki Metro 
const MetroView = () => import('@/views/metro/MetroView.vue')


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    /*redirect: "/system/overview", */
    redirect: '/login',
    children: [
      {
        path: '/system/overview',
        component: SystemOverview,
      },
      {
        path: '/devices',
        name: 'devices',
        component: Content,
        redirect: '/devices/infopoints',
        children: [
          {
            path: 'infopoints',
            component: Infopoints,
          },
          {
            path: 'ssedisplays',
            component: SseDisplays,
          },
          {
            path: 'ssedisplay_groups',
            component: DisplayGroups,
          },
          {
            path: 'powersockets',
            component: PowerSockets,
          },
          {
            path: 'devices',
            component: Devices,
          },
          {
            path: 'devicegroups',
            component: DeviceGroups,
          },
          {
            path: 'displaygroups',
            component: DisplayGroups,
          },
        ],
      },
      {
        path: '/content',
        name: 'content',
        component: Content,
        children: [
          {
            path: 'timetables',
            component: Timetables,
          },
          {
            path: 'displaylayouts',
            component: DisplayLayouts,
          },
          {
            path: 'info',
            component: TextAnnouncementsTabs,
          },
          {
            path: 'images',
            component: ImageAnnouncements,
          },
          {
            path: 'channels',
            component: Channels,
          },
          {
            path: 'media',
            component: Media,
          },
          {
            path: 'infopointlayouts',
            component: InfopointLayouts,
          },
        ],
      },
      {
        path: '/dispatching',
        name: 'dispatching',
        component: Content,
        children: [
          {
            path: 'usermessages',
            component: UserMessages,
          },
          {
            path: 'driverdocuments',
            component: DriverDocuments,
          },
          {
            path: 'events',
            component: Events,
          },
          {
            path: 'system_events',
            component: SystemEventTable,
          },
          {
            path: 'canceleddepartures',
            component: CanceledDepartures,
          },
          {
            path: 'traffic_deviations',
            component: TrafficDeviations,
          },
        ],
      },
      {
        path: '/timetables',
        name: 'timetables',
        component: Content,
        children: [
          {
            path: 'data',
            component: ToDo,
          },
          {
            path: 'stops',
            component: Stops,
          },
          {
            path: 'lines',
            component: Lines,
          },
          {
            path: 'routes',
            component: Routes,
          },
          {
            path: 'seasons',
            component: Seasons,
          },
          {
            path: 'daytypes',
            component: DayTypes,
          },
          {
            path: 'import',
            component: DataImport,
          },

          {
            path: 'importLogs',
            component: ImportLogs,
          },
          {
            path: 'import_table',
            component: DataImportTable,
          },
        ],
      },
      {
        path: '/realtime',
        name: 'realtime',
        component: Content,
        children: [
          {
            path: 'vehicles',
            component: Vehicles,
          },
          {
            path: 'vehiclegroups',
            component: VehicleGroups,
          },
          {
            path: 'drivingCycles',
            component: DrivingCycles,
          },
          {
            path: 'vehiclereport',
            component: VehicleReport,
          },
          {
            path: 'replacementRules',
            component: ReplacementRules,
          },
          {
            path: 'replacementRuleConfigs',
            component: ReplacementRuleConfigs,
          },
        ],
      },
      {
        path: '/reports',
        name: 'reports',
        component: Content,
        children: [
          {
            path: 'traveltime',
            component: TravelTimeReport,
          },
          {
            path: 'punctuality',
            component: PunctualityReport,
          },
          {
            path: 'stoppunctuality',
            component: StopPunctualityReport,
          },
          {
            path: 'block',
            component: BlockReport,
          },
          {
            path: 'trip',
            component: TripReport,
          },
          {
            path: 'omittedstops',
            component: OmittedStopsReport,
          },
          {
            path: 'vehiclehistory',
            component: VehicleHistoryReport,
          },
          {
            path: 'importlog',
            component: ImportLogReport,
          },
        ],
      },
      {
        path: '/reports2',
        name: 'reports2',
        component: Content,
        children: [
          {
            path: 'linepunctuality',
            component: LineDeviationReport,
          },
          {
            path: 'stoppunctuality',
            component: StopDeviationReport,
          },
          {
            path: 'vehiclepunctuality',
            component: VehicleDeviationReport,
          },
        ],
      },
      {
        path: '/reports3',
        name: 'reports3',
        component: Content,
        children: [
          {
            path: 'coursepunctuality',
            component: DynamicReport,
            props: {
              name: 'coursepunctuality',
              uuidName: 'OSD_COURSE_PUNCTUALITY',
            },
          },
          {
            path: 'stoppunctuality',
            component: DynamicReport,
            props: {
              name: 'stoppunctuality',
              uuidName: 'OSD_STOP_PUNCTUALITY',
            },
          },
          {
            path: 'vehiclepunctuality',
            component: DynamicReport,
            props: {
              name: 'vehiclepunctuality',
              uuidName: 'OSD_VEHICLE_PUNCTUALITY',
            },
          },
          {
            path: 'linepunctuality',
            component: DynamicReport,
            props: {
              name: 'linepunctuality',
              uuidName: 'OSD_LINE_PUNCTUALITY',
            },
          },
          {
            path: 'vehicleassignment',
            component: DynamicReport,
            props: {
              name: 'vehicleassignment',
              uuidName: 'OSD_VEHICLE_ASSIGNMENT',
            },
          },
          {
            path: 'mileage',
            component: DynamicReport,
            props: {
              name: 'mileage',
              uuidName: 'OSD_MILEAGE',
            },
          },
          {
            path: 'tripcompletion',
            component: DynamicReport,
            props: {
              name: 'tripcompletion',
              uuidName: 'OSD_TRIP_COMPLETION',
            },
          },
          {
            path: 'unservedtrip',
            component: DynamicReport,
            props: {
              name: 'unservedtrip',
              uuidName: 'OSD_UNSERVED_TRIP',
            },
          },
        ],
      },
      {
        path: '/print',
        name: 'print',
        component: Content,
        children: [
          {
            path: 'stops',
            component: PrintEditor,
          },
        ],
      },

      {
        path: '/map',
        name: 'map',
        component: Content,
        children: [
          {
            path: 'mapview',
            component: MapView,
          },
        ],
      },
      {
        path: '/vehicletable',
        name: 'vehicletable',
        component: Content,
        children: [
          {
            path: 'view',
            component: VehicleReport,
          },
        ],
      },
      {
        path: '/terminals',
        name: 'terminals',
        component: Content,
        children: [
          {
            path: 'terminalview',
            component: TerminalView,
          },
        ],
      },
      {
        path: '/metro',
        name: 'metro',
        component: Content,
        children: [
          {
            path: 'rtpi',
            component: MetroView,
          },
        ],
      },

      {
        path: '/system',
        name: 'system',
        component: Content,
        children: [
          {
            path: 'users',
            component: Users,
          },
          {
            path: 'usergroups',
            component: UserGroups,
          },
          {
            path: 'privileges',
            component: ToDo,
          },
          {
            path: 'organisations',
            component: Organisations,
          },
          {
            path: 'scheduledtasks',
            component: ScheduledTasks,
          },
          {
            path: 'airpollutionlimits',
            component: AirPollutionLimits,
          },
          {
            path: 'messagessettings',
            component: MessagesSettings,
            props: { messageType: 'DRIVER' },
          },
          {
            path: 'driverannouncements',
            component: MessagesSettings,
            props: { messageType: 'DRIVER_ANNOUNCEMENT' },
          },
          {
            path: 'deviationcolors',
            component: DeviationColors,
          },
          {
            path: 'virtualstops',
            component: VirtualStops,
          },
          {
            path: 'settings',
            component: Settings,
          },
          {
            path: 'maintenance',
            component: Maintenance,
          },
          {
            path: 'dev_test',
            component: DriverDocuments,
          },
        ],
      },
      {
        path: '/componentTest',
        name: 'componentTest',
        component: ComponentTest,
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// Mikäli kyseessä on WebComponent eli TravellerApp ei ohjata Login sivulle
router.webComponent = false

import store from '../store'
// Meidän pitää antaa routerille viittaus storeen koska routerin beforeEach anonyymit funkkarit ei muuten
// nää storea
router.store = store
router.beforeEach((to, _from, next) => {
  // TODO: redirect after login based on query param
  //  Mikäli kyseessä on web-component, ei ohjata login sivulle
  if (router.webComponent) {
    next()
    return
  }
  if (
    to.path === '/login' ||
    (router.store.getters.isAuthenticationOk && userHasPrivilege(to.path))
  ) {
    router.store.commit('setPath', to.path)

    next()
  } else {
    next({ path: '/login' })
  }
})

function userHasPrivilege(path) {
  return router.store.getters.userPrivileges.some((userPrivilege) => {
    return userPrivilege.indexOf('[UI]') > -1 && userPrivilege.endsWith(path)
  })
}

export default router
